export enum SlackChannel {
  Customer = 'customer',
  TeamVerification = 'team-verification',
  MailingList = 'mailing-list',
  AdContacts = 'ad-contacts',
  UserSignUp = 'user-sign-up',
  Stats = 'stats',
  SanityUpdates = 'sanity-updates',
  UserTeamInterest = 'user-team-interest',
}
